export const formatDate = (timestamp) => {
  const date = new Date(timestamp);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

export const formatTime = (
  timestamp,
  includeSeconds = false
  // includeMilliseconds = false // didn't work as expected
) => {
  const date = new Date(timestamp);
  return date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: includeSeconds ? "2-digit" : undefined,
    // millisecond: includeMilliseconds ? "3-digit" : undefined,
  });
};
